module.exports = __webpack_public_path__ + "/images/cover-cashback.26f7929.svg";